import apiClient from '../client.js'

export const paymentsAPI = {
  // Public payment endpoints
  async getPaymentMethods() {
    const response = await apiClient.get('/payments/methods')
    return response.data
  },

  async getBankTransferInfo() {
    const response = await apiClient.get('/payments/bank-transfer')
    return response.data
  },

  // Admin payment endpoints
  async getAdminPaymentMethods(params = {}) {
    const response = await apiClient.get('/admin/payments/methods', { params })
    return response.data
  },

  async getPaymentStats() {
    const response = await apiClient.get('/admin/payments/stats')
    return response.data
  },

  async createPaymentMethod(paymentData) {
    const response = await apiClient.post('/admin/payments/methods', paymentData)
    return response.data
  },

  async getPaymentMethod(paymentMethodId) {
    const response = await apiClient.get(`/admin/payments/methods/${paymentMethodId}`)
    return response.data
  },

  async updatePaymentMethod(paymentMethodId, paymentData) {
    const response = await apiClient.put(`/admin/payments/methods/${paymentMethodId}`, paymentData)
    return response.data
  },

  async deletePaymentMethod(paymentMethodId) {
    const response = await apiClient.delete(`/admin/payments/methods/${paymentMethodId}`)
    return response.data
  },

  async togglePaymentMethodActive(paymentMethodId) {
    const response = await apiClient.patch(`/admin/payments/methods/${paymentMethodId}/toggle-active`)
    return response.data
  },

  async updateOrderPaymentStatus(orderId, status) {
    const response = await apiClient.put(`/admin/payments/orders/${orderId}/status`, { status })
    return response.data
  },

  // Mollie checkout endpoints
  async createMolliePayment(orderNumber) {
    const response = await apiClient.post('/mollie/payments', { order_number: orderNumber })
    return response.data
  },

  async verifyMolliePayment(orderNumber) {
    const response = await apiClient.post('/mollie/verify', { order_number: orderNumber })
    return response.data
  },

  // Admin Mollie endpoints
  async getMollieMethods() {
    const response = await apiClient.get('/admin/mollie/methods')
    return response.data
  },

  async getMolliePaymentDetails(orderNumber) {
    const response = await apiClient.get(`/admin/mollie/orders/${encodeURIComponent(orderNumber)}/payment-details`)
    return response.data
  },

  async mollieRefundFull(orderNumber) {
    const response = await apiClient.post(`/admin/mollie/orders/${encodeURIComponent(orderNumber)}/refund`)
    return response.data
  },

  async mollieRefundPartial(orderNumber, amount) {
    const response = await apiClient.post(`/admin/mollie/orders/${encodeURIComponent(orderNumber)}/refund-partial`, { amount })
    return response.data
  }
}
